/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from "@/plugins";

// Components
import App from "./App.vue";

// Composables
import { createApp } from "vue";
import { useAppData } from "./composables/useAppData";
import { useAuthStore } from "./stores/auth";
import { useCashDrawerStore } from "./stores/cashDrawerStore";
import { useEnv } from "./composables/useEnv";
import "@fontsource/roboto/100.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/900.css";
import "@fontsource/roboto/100-italic.css";
import "@fontsource/roboto/300-italic.css";
import "@fontsource/roboto/400-italic.css";
import "@fontsource/roboto/500-italic.css";
import "@fontsource/roboto/700-italic.css";
import "@fontsource/roboto/900-italic.css";
import * as Sentry from "@sentry/vue";

const app = createApp(App);

registerPlugins(app);

const env = useEnv();

if (env.sentryDSN) {
  Sentry.init({
    app,
    dsn: env.sentryDSN,
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    integrations: [
      Sentry.feedbackIntegration({
        // Options to customize the widget appearance and behavior
        autoInject: true, // This adds a button to your page automatically
        // ... other configuration options
      }),
    ],
  });
  app.config.errorHandler = (err, instance, info) => {
    const eventId = Sentry.captureException(err);
    Sentry.showReportDialog({ eventId });
  };
} else {
  console.log("FAILED TO START SENTRY");
  console.log(env.sentryDSN);
}

app.mount("#app");

const appData = useAppData();
const authStore = useAuthStore();
const cashDrawerStore = useCashDrawerStore();

if (env.mode == "STAFF") authStore.whenLoggedIn(() => cashDrawerStore.init());

authStore.$subscribe(
  async (mutation) => {
    // Store the user state in localStorage
    localStorage.setItem(
      env.withPrefix("cbi_auth"),
      JSON.stringify(authStore.$state),
    );
  },
  { detached: true },
);
